module.exports = __webpack_public_path__ + "static/media/icon_arrow_drop_down.80539c6c.svg";